"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 16 16" id=icon-chevron-down-extra-small><path d="M12.194 6.306a.625.625 0 0 0-.881 0L8 9.62 4.694 6.306a.628.628 0 0 0-.888.888l3.75 3.75a.625.625 0 0 0 .882 0l3.75-3.75a.625.625 0 0 0 .006-.888Z"></path></symbol>';
}